
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"8","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.136.364a.9.9 0 00-1.272 0L1.136 6.09a.9.9 0 101.273 1.273L7.5 2.273l5.091 5.091a.9.9 0 001.273-1.273L8.136.364zM8.4 2V1H6.6v1h1.8z"}})])
          )
        }
      }
    